import {
  GET_TALENT_RESULT,
  SET_SHOW_MODAL_TALENT,
  SET_SELECT_ROLE_TALENT,
  SET_FILTER_ROLE_TALENT,
  SET_SHOW_ERROR_MODAL_TALENT,
  CLEAR_TALENT_INFO,
} from '../constants';
const initialState = {
  content: [],
  showModal: false,
  roleSelected: 'Todos',
  filterRole: '',
  showErrorModal: false,
};

export const resultTalent = (state = initialState, action) => {
  switch (action.type) {
    case GET_TALENT_RESULT:
      return {
        ...state,
        content: action.payload,
      };
    case SET_SHOW_MODAL_TALENT:
      return {
        ...state,
        showModal: action.payload,
      };
    case SET_SELECT_ROLE_TALENT:
      return {
        ...state,
        roleSelected: action.payload,
      };
    case SET_FILTER_ROLE_TALENT:
      return {
        ...state,
        filterRole: action.payload,
      };
    case SET_SHOW_ERROR_MODAL_TALENT:
      return {
        ...state,
        showErrorModal: action.payload,
      };
    case CLEAR_TALENT_INFO:
      return initialState

    default:
      return state;
  }
};

export default resultTalent;
